/**
 * The propose-result banner, identical across every propose flow: a PR was
 * opened, nothing is applied until it is approved. Shared by the two agent
 * surfaces (NewAgentArea, AgentProfileFacet), which are otherwise unrelated —
 * they only meet at POST /api/agents/propose.
 */
import { Link } from 'react-router-dom'
import type { ProposeSkillResult, RegistrationState } from '../api/client'

export function registrationTone(state?: RegistrationState): string {
  return state === 'pending'
    ? 'border-sky-200 bg-sky-50 text-sky-800'
    : 'border-amber-200 bg-amber-50 text-amber-800'
}

export function registrationButtonTone(state?: RegistrationState): string {
  return state === 'pending'
    ? 'border-sky-300 text-sky-800 hover:bg-sky-100'
    : 'border-amber-300 text-amber-800 hover:bg-amber-100'
}

export function ProposeResultBanner({ result }: { result: ProposeSkillResult }) {
  return result.improvement_warning ? (
    <div className={`rounded border px-3 py-2 text-xs space-y-1 ${registrationTone(result.registration_state)}`}>
      <p>{result.improvement_warning}</p>
    </div>
  ) : (
    <div className="rounded border border-green-200 bg-green-50 px-3 py-2 text-xs text-green-800 space-y-1">
      <p>Sent for review. Nothing changes until you approve it.</p>
      {result.improvement_id
        ? <Link to={`/improvements/${encodeURIComponent(result.improvement_id)}/pr`} className="font-medium underline">Review &amp; approve in Mission Control →</Link>
        : <span>Find it under <Link to="/improvements" className="font-medium underline">Improvements</Link>.</span>}
    </div>
  )
}
